import { render, staticRenderFns } from "./RepairDeleteMessage.vue?vue&type=template&id=71b0e62a"
import script from "./RepairDeleteMessage.vue?vue&type=script&lang=js"
export * from "./RepairDeleteMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports